<template>
  <div>
    <b-row class="mt-4 menu-items">
      <b-col class="text-left bg-t-dark-- side-menu-items-wrapper">
        <div v-for="i, index in menu_items" :key="index">
          <b-row 
            align-v="center" 
            :class="`${ $route.name == i.route ? 'active' : '' } side-menu-item menu-${i.route}`" 
            @click="open_(i.route)"
          >
            <b-col>
              <div class="menu-item-inner-div">
                <span>
                  <b-icon
                    font-scale="1.5"
                    :icon="i.icon"
                  />
                  &nbsp;
                  {{$t(i.name)}}
                </span>
                <span class="icon-bolder" v-if="i.open ||(i.child.length > 0 && isOpen(i.child))">
                  <b-icon-chevron-down/>
                </span>
              </div>
            </b-col>
          </b-row>
          <div v-if="i.open ||(i.child.length > 0 && isOpen(i.child))">
            <b-row
              v-for="c, index2 in i.child" 
              :key="index2"
              align-v="center" 
              :class="`${ $route.name == c.route ? 'active' : '' } side-menu-item menu-${c.route}`"
              @click="open_(c.route)"
            >
              <b-col>
                <div>
                  <span>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    {{$t(c.name)}}
                  </span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row align-v="center" :class="`side-menu-item side-item-bottom menu-logout`" @click="logout">
          <b-col>
            <div>
              <span>
                <logout/>
                &nbsp;
                {{$t("Logout")}}
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import bars from '@/assets/icons/bars'
import paper from '@/assets/icons/paper'
import folder from '@/assets/icons/folder'
import logout from '@/assets/icons/logout'
export default {
    components:{
      bars,
      paper,
      logout,
      folder,
    },
    data(){
      return {
        menu_items: [
          // {
          //   name: 'Dashboard',
          //   route: 'home',
          //   icon: 'bar-chart',
          //   child: []
          // },
          {
            name: 'Equipments',
            route: 'equipment-list',
            icon: 'file-earmark-text',
            open: true,
            child: [
              {
                name: 'Register',
                route: 'equipment-register'
              }
            ]
          },
          // {
          //   name: 'Orders',
          //   route: 'orders',
          //   icon: 'file-earmark-text',
          //   child: []
          // },
          // {
          //   name: 'Clients',
          //   route: 'clients',
          //   icon: 'folder',
          //   child: [
          //     {
          //       name: 'Equipments',
          //       route: 'equipment'
          //     }
          //   ]
          // },
        ]
      }
    },
    mounted(){
      this.$route.name
    },
    methods:{
      isOpen(child = []){
        return child.filter(c => {
          return c.route == this.$route.name
        }).length > 0
      },
      logout(){
        this.$store.commit('set_logged', false)
        this.$router.push('/')
      },
      open_(r){
        window.location.href = `#/${r}`
      },
    }
}
</script>

<style lang="scss">
  @media only screen and (min-width: 1000px) {
    .side-menu-items-wrapper{
      height: 80vh !important;
    }
    .side-item-bottom{
      position:absolute;
      bottom: 7vh;
      left: 25px;
      width: 224px;
    }
  }
  @media only screen and (max-width: 1000px) {
    .menu-items{
      margin-right: 0.1rem !important;
      margin-left: 0.1rem !important;
    }
  }
  .menu-item-inner-div{
    position: relative;
  }
</style>